export default "__VITE_ASSET__BxC2Yj3G__"